
export default [
    'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Jeanne+Leo/JL.webp'
    ,'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Jeanne+Leo/JL2.webp'
    ,'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Jeanne+Leo/JL3.webp'
    ,'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Jeanne+Leo/JL4.webp'
    ,'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Jeanne+Leo/JL5.webp'
    ,'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Jeanne+Leo/JL6.webp'
    ,'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Jeanne+Leo/JL7.webp'
    ,'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Jeanne+Leo/JL8.webp'
    ,'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Jeanne+Leo/JL1.webp'
    ,'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Jeanne+Leo/JL9.webp'
    ,'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Jeanne+Leo/JL10.webp'
    ,'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Jeanne+Leo/JL11.webp'
    ,'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/Jeanne+Leo/JL12.webp' 
];